import { useCallback, useEffect, useRef, useState } from 'react';
import { PaginationRequest } from 'models/common/Pagination';
import { getMemberHistotyList } from 'apis/vars/member/Member';
import { MemberVO } from 'models/vars/member/MemberVO';
import { useLoading } from 'components/process/Loading';
import { useMessageBar } from 'components/process/MessageBar';
import { PaginationRef } from 'components/layouts/GPagination';
import { getCommonCodes } from 'apis/admin/CommonCode';
import { CommonCode } from 'models/admin/CommonCode';
import DataArea from './DataArea';
import SearchArea from './SearchArea';
import { useTranslation } from 'react-i18next';

export interface ReqMemberVO extends PaginationRequest {
  soprMgrNm?: string;
  vdcpNm?: string;
  vdcpErpNm?: string;
  vdcpCd?: string;
  vdcpMgrNm?: string;
  vdcpMgrEmal?: string;
  soprMgrCopCd?: string;
  dataInsDtm?: string;
  regReqDt?: string;
  regReqDtSt?: string;
  regReqDtEnd?: string;
  mbrPsgStatCd?: string;
  dataInsUserNm?: string;
}

export interface RespMemberVO {
  vdcpCd: string;
  vdcpNm: string;
  vdcpErpNm: string;
  vdcpMgrNm: string;
  vdcpMgrEmal: string;
  soprMgrCopCd: string;
  soprMgrNm: string;
  dataInsDtm: string;
  regReqDt: string;
  regReqDtSt?: string;
  regReqDtEnd?: string;
  mbrPsgStatCdNm: string;
}

const InitMemberListGrid: RespMemberVO = {
  vdcpCd: '',
  vdcpNm: '',
  vdcpErpNm: '',
  vdcpMgrNm: '',
  vdcpMgrEmal: '',
  soprMgrCopCd: '',
  soprMgrNm: '',
  dataInsDtm: '',
  regReqDt: '',
  regReqDtSt: '',
  regReqDtEnd: '',
  mbrPsgStatCdNm: '',
};

const MemberHistoryPage = () => {
  //
  const { t } = useTranslation();
  const { openLoading } = useLoading();
  const { openMessageBar } = useMessageBar();
  const paginationRef = useRef<PaginationRef>(null);

  const [memberList, setMemberList] = useState<RespMemberVO[]>([InitMemberListGrid]);

  const [totalCount, setTotalCount] = useState<number>(0);

  const [pageNo, setPageNo] = useState<number>(1);

  const [pageSizeList, setPageSizeList] = useState<any>([]);

  const [statCdList, setStatCdList] = useState<CommonCode[]>([]);

  const [searchParams, setSearchParams] = useState<ReqMemberVO>({
    soprMgrNm: '',
    vdcpNm: '',
    vdcpCd: '',
    vdcpMgrNm: '',
    vdcpMgrEmal: '',
    soprMgrCopCd: '',
    dataInsDtm: '',
    regReqDt: '',
    regReqDtSt: '',
    regReqDtEnd: '',
    pageSize: '30',
    start: '0',
    mbrPsgStatCd: '',
  });

  const getPageSizeData = useCallback(() => {
    //
    getCommonCodes('PG_ROW_CNT_CD').then((result: CommonCode[]) => {
      const resList = result
        .filter((item) => 'Y' === item.useYn)
        .filter((item) => '15' !== item.cmnCd)
        .map((item) => item.cmnCdNm)
        .filter(Boolean);
      setPageSizeList(resList);
    });
  }, []);

  useEffect(() => {
    getCommonCodes('MBR_H_STAT_CD').then((result: CommonCode[]) => {
      setStatCdList(result);
    });
    getPageSizeData();
  }, []);

  useEffect(() => {
    search(false, searchParams);
  }, []);

  function search(isPage: boolean, condition: ReqMemberVO) {
    const param = condition ?? searchParams;
    const start = isPage ? param.start : '0';
    getMemberHistotyList({ ...param, start } as MemberVO)
      .then((data) => {
        if (data) {
          const list = data.list as RespMemberVO[];
          setMemberList(() => {
            return [...list];
          });
          setTotalCount(() => {
            return data.totalCount;
          });
          if (!isPage) {
            setPageNo(1);
            paginationRef.current?.setSelectNo(1);
          }
        }
      })
      .catch(handleError);
  }

  function handleError(e: Error) {
    openLoading(false);
    openMessageBar('error', e.message);
  }

  return (
    <>
      <SearchArea
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        search={search}
        statCdList={statCdList}
      />
      <DataArea
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        search={search}
        paginationRef={paginationRef}
        memberList={memberList}
        setMemberList={setMemberList}
        pageNo={pageNo}
        setPageNo={setPageNo}
        totalCount={totalCount}
        pageSizeList={pageSizeList}
      />
    </>
  );
};

export default MemberHistoryPage;
